import axios from 'axios';
import { API_BASE_URL, LOGOUT } from '../services/apiConfig';
import { useNavigate } from "react-router-dom";

function Logout() {
  const navigate = useNavigate();
  axios.post(API_BASE_URL + LOGOUT)
  .then((response) => {
    sessionStorage.clear();
    //window.location.href = '/login';
    navigate("/login");
  })
  .catch((error) => {
     console.error(error);
  });
}

export default Logout;